import { Link } from 'react-router-dom';
import { FiFacebook, FiInstagram } from 'react-icons/fi';
import BrandLogo from '../common/BrandLogo';

export default function Footer() {
  return (
    <footer className="bg-yamass-black text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">

          {/* Brand */}
          <div className="md:col-span-1">
            <BrandLogo size="lg" className="mb-4" framed />
            <p className="text-gray-400 text-sm leading-relaxed">
              Quality clothing for the whole family. Based in Bangladesh, delivering across the country.
            </p>
            <div className="flex gap-4 mt-5">
              <a href="https://facebook.com" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-yamass-accent transition-colors">
                <FiFacebook size={20} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-yamass-accent transition-colors">
                <FiInstagram size={20} />
              </a>
            </div>
          </div>

          {/* Shop */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-yamass-accent mb-4">Shop</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/shop/shirts"      className="hover:text-white transition-colors">Shirts</Link></li>
              <li><Link to="/shop/pants"       className="hover:text-white transition-colors">Pants</Link></li>
              <li><Link to="/shop/baby-clothes" className="hover:text-white transition-colors">Baby Clothes</Link></li>
              <li><Link to="/shop/kids-clothes" className="hover:text-white transition-colors">Kids</Link></li>
              <li><Link to="/shop/teen-clothes" className="hover:text-white transition-colors">Teens</Link></li>
            </ul>
          </div>

          {/* Account */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-yamass-accent mb-4">Account</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/login"    className="hover:text-white transition-colors">Login</Link></li>
              <li><Link to="/register" className="hover:text-white transition-colors">Register</Link></li>
              <li><Link to="/orders"   className="hover:text-white transition-colors">My Orders</Link></li>
              <li><Link to="/profile"  className="hover:text-white transition-colors">My Profile</Link></li>
            </ul>
          </div>

          {/* Help */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-yamass-accent mb-4">Help</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Return Policy: 7 days</li>
              <li>Free shipping over ৳1000</li>
              <li>Payment: bKash, Nagad, Card, COD</li>
              <li className="pt-2">
                <a href="mailto:support@yamass.com" className="hover:text-white transition-colors">
                  support@yamass.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-6 text-center text-xs text-gray-600">
          © {new Date().getFullYear()} YAMASS Bangladesh. All rights reserved. Made in Bangladesh 🇧🇩
        </div>
      </div>
    </footer>
  );
}
